import {Component, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {ICellEditorAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'validation-text-editor',
    template: `<input (keyup)="onChange($event)"[class]="errCls?errCls:null" style="width:150px;height:28px" type="text"[(ngModel)]="value" >
    @if (toolTipShow) {
      <div class="tooltip_grid">
        <span id="tooltiptext" class="tooltiptext_grid">
          {{tooltipMessage}}
        </span>
      </div>
    }`,
     styleUrls: [
        "./harvest-tax-loss-rebalance-setting/harvest-tax-loss-rebalance-setting.component.scss",
    ],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class validationPercentCellEditorComponent implements ICellEditorAngularComp {
    params: any;
    value: any;
    oldValue:any;
    regex:RegExp= /^\d+$/;
    toolTipShow:boolean=false;
    errorFlag:boolean;
    tooltipMessage:any="";
    errCls:any="";
    agInit(params: any): void {
        this.params = params;
        this.oldValue = this.params.data.extraCashAmount;
        this.value=this.params.data.extraCashAmount;
        this.tooltipMessage="";
        this.errorFlag=false;
        this.toolTipShow=false;
        this.errCls="";
    }

    getValue(): any {
        if(!this.errorFlag)
        {
            window.setTimeout(() => {
                if (this.params && this.params.context && this.params.context.componentParent)
                    this.params.context.componentParent.onExtraCashValueChange(this.params,this.oldValue,this.value);
            },0);

        }
        else{
            this.value=this.oldValue;
        }
        return this.value;  
    }

    onChange(event: any) {
        //console.log(event.target.value);
        if(event.target.value)
        {
            if(!this.regex.test(event.target.value.toString().trim()))
        {
            this.tooltipMessage="Please select a valid value";
            this.errorFlag=true;
            this.toolTipShow=true;
            this.errCls="err-invalid";
        }
        else{
            this.tooltipMessage="";
            this.errorFlag=false;
            this.toolTipShow=false;
            this.errCls="";
        }
        }
    else{
        this.tooltipMessage="";
        this.errorFlag=false;
        this.toolTipShow=false;
        this.errCls="";
    }
        
    }

    isPopup() {
        return true;
    }
}
